import React from 'react';
import BillingReportsForm from 'src/components/billing/billingReports/BillingReportsForm';
// import {billingReportsForm} from '../../../components/billing/billingReports/billingReportsForm';

const AddBillingReports = () => (
  <div><BillingReportsForm /></div>
);

export default AddBillingReports;
